import * as React from "react";
import { container } from "./ParagraphFeaturedDestinations.module.scss";
import { alt } from "../../../styles/global.module.scss";

export const Container: React.FC<any> = (props) => {
  let cssClass = "";
  if (props.bgColor === "alt") {
    cssClass = alt;
  }
  return <div className={`${container} ${cssClass}`}>{props.children}</div>;
};
